<template>
  <ImpactCarousel
    v-if="posts"
    :posts="
      block.purpose === 'explore' ? formatArticles(data?.allArticles) : posts
    "
    :block="block"
    :row-position="rowPosition"
    :unique-id="block.id"
  />
</template>

<script setup>
import { buildMultiFilteredArticleListGql } from '~/gql/explore/article.gql.js'
const props = defineProps({
  block: { type: Object, required: true },
  rowPosition: { type: Number, default: 0 },
})

const { data, execute } = await useDatoQuery({
  query: buildMultiFilteredArticleListGql(
    // gql query needs a formatted JSON array string for in: and integer for first:
    props.block.exploreCategories.length
      ? `[${props.block.exploreCategories
          .map((cat) => `"${cat.id}"`)
          .join(',')}]`
      : null,
    8
  ),
  immediate: false,
})

const posts = computed(() => {
  if (props.block.purpose === 'explore') {
    execute()
  }
  return props.block.cards
})

function formatArticles(posts) {
  return posts.map((p) => ({
    title: p.title,
    description: p.subtitle,
    media: p.media,
    url: `/explore/${p.category?.slug}/${p.slug}`,
    id: p.id,
    trackingId: p.title,
    type: 'article',
  }))
}
</script>

<style lang="postcss"></style>
